import { useMemo, type FC } from 'react';

import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { useSettingsSlice } from '@pp/core/src/store/slices/settings/selectors';
import { formatNumber } from '@pp/core/src/utils/formatters';

import styles from './CrashGameHelp.module.css';

export const CrashHelpChapterMultiplier: FC = () => {
  const maxMultiplier = useConfigSlice.tableConfig()?.maxMultiplier;
  const locale = useSettingsSlice.currentLanguage();

  const formattedMultiplier = useMemo(() => {
    return formatNumber(locale, Number(maxMultiplier));
  }, [locale, maxMultiplier]);

  return (
    <div>
      <p>
        <HelpText dynamicValues={{ multipliervalue: `${formattedMultiplier}` }} tk="multiplier.multiplier" />
      </p>
      <div className={styles.mulVal}>2.00x</div>
      <p>
        <HelpText tk="multiplier.maxPayout" markdown />
      </p>
    </div>
  );
};
